import { ChangeEvent } from 'react';
import {
  Button,
  Grid,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import Iconify from '@/components/Iconify';
import {
  ScheduledJobExecutionType,
  ScheduledJobListFilters,
} from '../types/scheduled-jobs';

type ScheduledJobsTableToolbarProps = {
  filters: ScheduledJobListFilters;
  onFilters: (name: keyof ScheduledJobListFilters, value: string) => void;
  onResetFilters: VoidFunction;
  isFiltered: boolean;
};

const EXECUTION_TYPES: ScheduledJobExecutionType[] = ['HTTP', 'INTERNAL'];

export default function ScheduledJobsTableToolbar({
  filters,
  onFilters,
  onResetFilters,
  isFiltered,
}: ScheduledJobsTableToolbarProps) {
  const handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    onFilters('search', event.target.value);
  };

  const handleSelectChange =
    (name: keyof ScheduledJobListFilters) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      onFilters(name, event.target.value);
    };

  return (
    <Grid container spacing={2} sx={{ py: 2.5, px: 3 }}>
      <Grid item xs={12} md={4}>
        <TextField
          value={filters.search}
          onChange={handleTextChange}
          fullWidth
          size="small"
          placeholder="Search scheduled jobs"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-outline" width={20} />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Enabled"
          value={filters.enabled}
          onChange={handleSelectChange('enabled')}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="enabled">Enabled</MenuItem>
          <MenuItem value="disabled">Disabled</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Execution type"
          value={filters.executionType}
          onChange={handleSelectChange('executionType')}
        >
          <MenuItem value="">All</MenuItem>
          {EXECUTION_TYPES.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {isFiltered && (
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end">
            <Button
              color="inherit"
              onClick={onResetFilters}
              startIcon={<Iconify icon="eva:close-circle-outline" />}
            >
              Reset filters
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}
